import React, { useMemo, useState } from 'react';
import PortfolioSimulator from '../../components/PortfolioSimulator';
import usePersonalSimData from './usePersonalSimData';
import MyStrategiesManager from './MyStrategiesManager';
import './personal.css';

/*
 * The company Portfolio Simulator plus the member's own accounts and
 * strategies as extra tabs, so they can be mixed with the company's
 * strategies. The member's own data stays theirs: nothing is added to the
 * company (that's Brand Admin and above, on the brand's Strategies page).
 */
export default function CompanySimulatorWithMine({ user, onUpgrade }) {
  const { data, requiresPro, myStrategies, reload } = usePersonalSimData();
  const [managing, setManaging] = useState(false);

  const personal = useMemo(() => {
    // Without Pro access to their own data the simulator is just the company's.
    if (requiresPro) return null;
    return {
      ...data,
      // Personal load problems never block the company's strategies.
      error: null,
      headerAction: (
        <button type="button" className="mys-btn" onClick={() => setManaging(true)}>
          My strategies{myStrategies.length ? ` (${myStrategies.length})` : ''}
        </button>
      ),
    };
  }, [data, requiresPro, myStrategies.length]);

  return (
    <>
      <PortfolioSimulator user={user} onUpgrade={onUpgrade} personal={personal} />
      {managing ? <MyStrategiesManager strategies={myStrategies} onClose={() => setManaging(false)} onChanged={reload} /> : null}
    </>
  );
}
